import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';

import OrderableStack from '../../../components/OrderableStack';
import AddIconButton from '../../../components/buttons/AddIconButton';

const useStyles = makeStyles((theme) => ({
	root: {
		composes: 'flexColumn stretch center spaceBetween',
		minWidth: 150,
		maxWidth: 300,
		// height: '80vh',
		flex: 1,
		overflow: 'auto'
	},
	header: {
		composes: 'flexRow center',
		width: '100%',
		borderBottom: theme.border.grey[630]
	},
	title: {
		composes: 'flex1',
		fontSize: 18,
		padding: 10
	},
	items: {
		composes: 'flexColumn',
		width: '100%',
		justifyContent: 'flex-end'
	},
	item: {
		width: '100%',
		composes: 'flexCenter',
		cursor: 'pointer',
		height: 40,
		borderTop: theme.border.green[710],
		'&:hover': {
			backgroundColor: theme.background.blue[570]
		},
		'&:focus, &:active': {
			backgroundColor: theme.background.blue[585]
		}
	},
	selectedItem: {
		backgroundColor: theme.background.blue[585]
	},
	addButton: {
		background: theme.background.blue[590]
	},
	background: {
		composes: 'flex1 stretchSelf',
	},
}));

const LayersList = (props) => {
	// styles
	const classes = useStyles(props);
	
	// props
	const { 
		layers = [], 
		onOpenAddDialog,
		onOrderChange,
		selectedLayer,
		onSelection, 
		onDelete, 
		onDeselection,
		selectedItemsMask,
		onSelectItemsMask,
		onOrderItemsMask,
		onRemoveItemMask,
		toggleVisibility,
		onChangeUsedForPrint,
 } = props;
	
	const _onOpenDialog = (event)=>{
		event.stopPropagation();
		onOpenAddDialog();
	}

	return (
		<div className={classes.root}>
			<div className={classes.header}>
				<div className={classes.title}>Calques</div>
				<AddIconButton onAdd={_onOpenDialog } color='default'/>
			</div>

			<div className={classes.background} onClick={onDeselection} />

			<div className={classes.items}>
				<OrderableStack
					items={layers}
					onSelect={onSelection}
					selectedItem={selectedLayer}
					onDelete={onDelete}
					onOrderChange={onOrderChange}
					onOpenAddDialog={onOpenAddDialog}
					withDeleteButton
					onSelectItemsMask={onSelectItemsMask}
					onOrderItemsMask={onOrderItemsMask}
					onRemoveItemMask={onRemoveItemMask}
					selectedItemsMask={selectedItemsMask}
					toggleVisibility={toggleVisibility}
					onChangeUsedForPrint={onChangeUsedForPrint}
				/>
			</div>
		</div>
	);
};

LayersList.propTypes = {
	layers: PropTypes.array,
	onOpenAddDialog: PropTypes.func,
	onOrderChange: PropTypes.func,
	selectedLayer: PropTypes.any,
	onSelection: PropTypes.func,
	onDelete: PropTypes.func,
	onDeselection: PropTypes.func,
};
export default LayersList;
